import Address from 'src/models/address'
import BaseGeocodeService from '../../baseGeocodeService'
import serverConfig from 'src/server_config.js'

const REQUEST_HEADERS = {
  "Content-Type": "application/json; charset=utf-8"
}

class ClickGoGeocodeService extends BaseGeocodeService {
  constructor (serviceUrl, serviceToken) {
    super()
    this.serviceUrl = serviceUrl
    this.serviceToken = serviceToken
  }

  /**
   * Get reversed geocoded address
   *
   * @param {Latitude} latitude
   * @param {Longitude} longitude
   */
  async reverseGeocode (latitude, longitude) {
    // build proper request with one position
    const requestBody = {
      "geoRef":
      {
        "token": this.serviceToken,
        "coordenadas": [
            {
              "idPosicion": 1,
              "latitud": latitude,
              "longitud": longitude
            }
        ]
      }
    }

    // POST request using fetch with async/await
    const result = await fetch(this.serviceUrl, {method: 'POST', headers: REQUEST_HEADERS, body: JSON.stringify(requestBody)})
    .then(response =>response.json())
    .catch(error => {throw new Error(`There was an error geocoding (${latitude}, ${longitude})\n ${error}`)});

    // check if there is any error
    if (result.GetGeoRefByCoordsResult.error !== '') {
      throw new Error(`There was an error geocoding (${latitude}, ${longitude})\n ${result.GetGeoRefByCoordsResult.error}`)
    }

    // check if there is at least one item
    if (result.GetGeoRefByCoordsResult.items.length === 0) {
      return null
    }

    //build proper response with the first item
    const addressFields = result.GetGeoRefByCoordsResult.items[0]
    const response = new Address.Builder()
       .setNumber(addressFields.CP_Desde + '/' + addressFields.CP_Hasta)
       .setStreet(addressFields.callePrincipal)
       .setNeighbourhood(addressFields.barrioCapFed ? addressFields.barrioCapFed : addressFields.depto)
       .setCity(addressFields.localidad)
       .setState(addressFields.provincia)
       .setCountry(addressFields.pais)
       .setFullAddress(addressFields.literal)
       .build()

    return response
  }
}

const geocodeService = new ClickGoGeocodeService(serverConfig.clickgo_url, serverConfig.clickgo_token)
export default geocodeService



// WEBPACK FOOTER //
// ./src/services/geocoding/implementations/clickgo/clickgoGeocodeService.js